// extracted by mini-css-extract-plugin
export default {"container":"_3MFdIBa","label":"Ax3SDCg","select":"_14tDDoF"};